import { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover'
import { useNotifications } from '@/contexts/NotificationsContext'
import { NotificationBell } from './NotificationBell'
import { NotificationPanel } from './NotificationPanel'
import { cn } from '@/lib/utils'

interface NotificationCenterProps {
  className?: string
}

export function NotificationCenter({ className }: NotificationCenterProps) {
  const { t } = useTranslation('app')
  const [open, setOpen] = useState(false)
  const wasOpenRef = useRef(false)
  const { markAllRead } = useNotifications()

  function handleOpenChange(nextOpen: boolean) {
    if (wasOpenRef.current && !nextOpen) {
      markAllRead()
    }
    wasOpenRef.current = nextOpen
    setOpen(nextOpen)
  }

  return (
    <Popover open={open} onOpenChange={handleOpenChange}>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid="notification-center"
          aria-label={t('notifications.aria')}
          className={cn(
            'flex items-center justify-center transition-colors',
            className,
          )}
        >
          <NotificationBell />
        </button>
      </PopoverTrigger>
      <PopoverContent
        align="end"
        side="right"
        sideOffset={8}
        collisionPadding={16}
        className="w-80 overflow-hidden p-0 sm:w-96 max-h-[min(24rem,var(--radix-popover-content-available-height))]"
      >
        <NotificationPanel />
      </PopoverContent>
    </Popover>
  )
}
